function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPc02 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.40359,74.72425,54.20928,80.7426l-3.429-2.59695A74.61956,74.61956,0,0,1,30.24639,54.15991l-2.03033-3.78015,6.371-.69363",
    style: {
      fill: "none",
      stroke: "#0f62fe",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3875445234001262px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "41.584 77.823 37.962 85.463 36.62 81.347 32.77 87.902 32.719 82.47 9.516 89.486 22.594 68.876 17.371 68.056 26.688 65.143 22.971 62.788 29.91 61.201",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3875445234001262px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.56893,18.80508A34.57268,34.57268,0,0,0,91.449,41.01249",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3875445234001262px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.86214,27.03542c4.53673,18.2914,26.4609,43.51852,43.97748,48.81533",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3875445234001262px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.11611,76.60922a16.54169,16.54169,0,0,1-20.83842.60885,94.3795,94.3795,0,0,1-26.2607-30.857,16.46715,16.46715,0,0,1,2.334-18.59518,16.27909,16.27909,0,0,1,6.49442-4.455c.28163-.101.54229-.1967.8155-.27781a69.717,69.717,0,0,1,15.64033-3.577,94.551,94.551,0,0,1,12.21507-.652c1.85272.016,3.61953.08,5.27436.17616A16.5417,16.5417,0,0,1,91.47129,34.86271c.06432,1.96164.05765,3.8698-.00649,5.72562A81.23843,81.23843,0,0,1,89.648,55.05114a81.09721,81.09721,0,0,1-4.3986,13.801c-.33408.76724-.65245,1.50837-.98962,2.22747A16.23316,16.23316,0,0,1,80.11611,76.60922Z",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3875445234001262px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.97018,
    cy: 44.13928,
    rx: 9.8433,
    ry: 8.52478,
    transform: "translate(-12.25918 57.57463) rotate(-43.53074)",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeMiterlimit: 10,
      strokeWidth: "1.3875445234001262px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.40845,29.35742c-4.43366,1.87128-9.15871.75055-10.52251-2.50233a5.33654,5.33654,0,0,1,.06064-4.09114A69.90035,69.90035,0,0,1,59.64075,19.4389a6.30671,6.30671,0,0,1,.32931.63293C61.34353,23.31682,58.85966,27.48781,54.40845,29.35742Z",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeMiterlimit: 10,
      strokeWidth: "1.3875445234001262px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3296,53.9551a4.72047,4.72047,0,0,0-.95247-.80847c-2.96783-1.92159-7.49639-.1842-10.11319,3.86874-2.60732,4.04484-2.31771,8.89231.65959,10.80581a5.94052,5.94052,0,0,0,6.00507-.06586l.00947-.00809",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.3875445234001262px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98755,27.25837a6.53743,6.53743,0,0,0,5.53374-5.534h.13229a6.53741,6.53741,0,0,0,5.53373,5.534v.13224a6.5374,6.5374,0,0,0-5.53369,5.53352h-.13238a6.53738,6.53738,0,0,0-5.53369-5.53352Z",
    style: {
      fill: "#ffcd4d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.62663,7.22408A3.79919,3.79919,0,0,0,66.84254,4.008h.07688a3.79921,3.79921,0,0,0,3.21591,3.21606v.07686a3.79918,3.79918,0,0,0-3.21588,3.21578h-.07693a3.79917,3.79917,0,0,0-3.21589-3.21578Z",
    style: {
      fill: "#ffcd4d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.93862,90.26723a2.35978,2.35978,0,0,0,1.99749-1.99759h.04776a2.35978,2.35978,0,0,0,1.99749,1.99759V90.315a2.35979,2.35979,0,0,0-1.99748,1.99742H81.9361A2.35978,2.35978,0,0,0,79.93862,90.315Z",
    style: {
      fill: "#ffcd4d",
      fillRule: "evenodd"
    }
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPc02);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PC02.808080959f8cd3c56d0aa286f14bba11.svg";